(function ($, window, document, undefined) {
	$(document).ready(function () {
		/**
		 * Scroll to anchor
		 */
		function smoothAutoScrollToAnchor() {
			let wpAdminBarHeight = 0;

			// get current window width
			function getWindowWidth() {
				let width = $(window).outerWidth();

				// check if admin bar is present
				if ($("body").hasClass("admin-bar")) {
					if (width >= 783) {
						wpAdminBarHeight = 32;
					}
					;

					if (width <= 782) {
						wpAdminBarHeight = 46;
					}
					;
				}
				;
			};

			$(".wm-hero-text .wm-hero-text__limited-offer a, .wm-hero-text .button").on("click", function () {
				let headerHeight = $(".header").outerHeight();
				let content = $($.attr(this, "href"));

				if (content.length !== 0) {
					$("html, body")
						.stop()
						.animate(
							{
								scrollTop:
									$($.attr(this, "href")).offset().top -
									headerHeight -
									wpAdminBarHeight -
									15,
							},
							500,
						);
				} else {
					return;
				}
			});

			// initial function call
			getWindowWidth();

			// call function on window resize
			$(window).on("resize", function () {
				getWindowWidth();
			});
		};

		/**
		 * Top header slider
		 */
		function topHeaderSlider() {
			const sliderOptions = {
				infinite: false,
				autoplay: false,
				arrows: true,
				prevArrow: `<button type="button" class="arrow-prev">
											<svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M-0.000244075 5.5L6.74976 0.73686L6.74976 10.2631L-0.000244075 5.5Z" fill="black"/>
											</svg>
										</button>`,
				nextArrow: `<button type="button" class="arrow-next">
											<svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M6.99978 5.50829L0.241142 10.2592L0.258439 0.732904L6.99978 5.50829Z" fill="black"/>
											</svg>
										</button>`,
				dots: false,
				responsive: [
					{
						breakpoint: 576,
						settings: {
							useTransform: false,
							speed: 300,
						},
					},
				],
			};

			$(".top-header-slider").slick(sliderOptions);
		}

		/**
		 * Weedmaps videos
		 */
		function weedmapVideos() {
			$(".popup-youtube, .popup-vimeo, .popup-gmaps").magnificPopup({
				disableOn: 0,
				type: "iframe",
				mainClass: "mfp-fade",
				removalDelay: 160,
				preloader: false,
				fixedContentPos: true,
			});
		}

		/**
		 * Slider initializer
		 */
		function initializeSliderHandler(mobileSlider = null, regularSlider = null, mobileSliderWidth, carousel, mobileOptions = null, regularOptions = null) {
			if (carousel.length !== 0) {
				if (mobileSlider && !regularSlider) {
					// slick only on mobile
					if ($(window).width() > mobileSliderWidth) {
						if (carousel.hasClass("slick-initialized")) {
							carousel.slick("unslick");
						}
					} else {
						if (!carousel.hasClass("slick-initialized")) {
							carousel.slick(mobileOptions);
						}
					}
				} else if (regularSlider && !mobileSlider) {
					// slick only on desktop
					if ($(window).width() <= mobileSliderWidth) {
						if (carousel.hasClass("slick-initialized")) {
							carousel.slick("unslick");
						}
					} else {
						if (!carousel.hasClass("slick-initialized")) {
							carousel.slick(regularOptions);
						}
					}
				} else if (regularSlider && mobileSlider) {
					// slick for desktop & mobile
					if (!carousel.hasClass("slick-initialized")) {
						carousel.slick(regularOptions);
					}
				}
			}
		}

		/**
		 * Features slider
		 */
		function featuresSlider() {
			const mobileSlider = Boolean($(".product-image-block-features.use-mobile-slider").length);
			const mobileCarouselSelector = $(".product-image-block-features.use-mobile-slider");
			let resizeTimeout;

			const mobileOptions = {
				slidesToShow: 2,
				autoplay: true,
				arrows: true,
				prevArrow: `<button type="button" class="arrow-prev"><</button>`,
				nextArrow: `<button type="button" class="arrow-next">></button>`,
				dots: false,
				responsive: [
					{
						breakpoint: 576,
						settings: {
							slidesToShow: 1,
							useTransform: false,
							speed: 300,
						},
					},
				],
			};

			initializeSliderHandler(mobileSlider, null, 1023, mobileCarouselSelector, mobileOptions);

			$(window).on("resize", function () {
				// Debounced resize
				clearTimeout(resizeTimeout);

				resizeTimeout = setTimeout(function () {
					initializeSliderHandler(mobileSlider, null, 1023, mobileCarouselSelector, mobileOptions);

					clearTimeout(resizeTimeout);
				}, 100);
			});
		}

		/**
		 * Variative product price
		 */
		function variativeProductData() {
			let intervalId;
			let clonedPrice;

			$(".vi-wpvs-option-wrap").on("click", function () {
				const $this = $(this);
				const variations = JSON.parse($this.closest("form.cart").attr("data-product_variations"));
				const selectedVariation = $this.attr("data-attribute_value");
				const selectedVariationLabel = $this.attr("data-attribute_label");
				let currentVariation;
				const pricesWrapper = $this.closest(".product-description-block").find(".prices-wrapper");
				const mobilePricesWrapper = $this.closest(".wm-product-content").find(".product-mobile-description .prices-wrapper");

				clearInterval(intervalId);

				intervalId = setInterval(function () {
					const wooVariationPriceWrapper = $this.closest("form.cart").find(".woocommerce-variation-price").eq(0);

					if (wooVariationPriceWrapper.length !== 0 && wooVariationPriceWrapper.children().length !== 0) {

						let discount = null;

						function calculateDiscount() {
							variations.forEach(function (item) {
								let obj = item.attributes;

								Object.keys(obj).forEach(function (key) {
									if (obj[key] === selectedVariation) {
										currentVariation = item;
									}
								});
							});

							// Get discount in %
							discount = Math.floor(((currentVariation.display_regular_price - currentVariation.display_price) / currentVariation.display_regular_price) * 100);
						}

						// Calculate discount
						calculateDiscount();

						// Clearing blocks
						pricesWrapper.empty();
						mobilePricesWrapper.empty();

						// Appending price to another block
						wooVariationPriceWrapper.appendTo(pricesWrapper);

						// Append discount
						if (discount > 0) {
							pricesWrapper.append(`<div class="discount">Save ${discount}%</div>`);
							mobilePricesWrapper.append(`<div class="discount">Save ${discount}%</div>`);
						}

						// Clearing previously cloned data
						clonedPrice = null;

						// Clone new data
						clonedPrice = pricesWrapper.find(".woocommerce-variation-price").clone(true);

						// Appending price to another block
						clonedPrice.appendTo(mobilePricesWrapper);

						clearInterval(intervalId);
					} else {
						clearInterval(intervalId);
					}

					let pickFlavor = $this.closest(".product-description-block").find(".pick-flavor");
					let pickedFlavor = pickFlavor.find(".picked-flavor");
					// Show selected flavor
					pickedFlavor.empty();
					pickedFlavor.text(selectedVariationLabel);
				}, 10);
			});
		}

		function init() {
			smoothAutoScrollToAnchor();
			topHeaderSlider();
			weedmapVideos();
			featuresSlider();
			variativeProductData();
		}

		init();
	});
})(jQuery, window, document);
